import Container from '@material-ui/core/Container'
import moment from 'moment'
import React from 'react'
import ImgUtil from '../../../../utils/img.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import Bio from '../../../global/bio'
import BlogFeaturedResource from '../../../global/blogFeaturedResource'
import Breadcrumbs from '../../../global/breadcrumbs'
import RelatedArticles from '../../../global/relatedArticles'
import SEOTags from '../../../global/seoTags'
import Subscribe from '../../../global/subscribe'
import SubscribeModal from '../../../global/subscribeModal'
import Typography from '../../../global/typography'
import Layout from '../../../layouts/layout'
import BlogNavigation from '../navigation'
import { BlogPostContainer, TagsContainer } from './style'
//helpers
import { OPTIONS } from '../../../../constants/dateOptions'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../utils/blog.utils'
import { findTarget } from '../../../../utils/microcopy.utils'
import WrapperImage from '../../../global/wrapperImage'

const BlogPost = ({
  path,
  pageContext,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}: any) => {
  if (pageContext.blogPostData) {
    const isSecondaryBlog = pageContext.isSecondaryBlog

    let seoData
    if (isSecondaryBlog) {
      seoData = pageContext.blogPostData.seoMetadata ? pageContext.blogPostData.seoMetadata : null
    } else {
      seoData = pageContext.blogPostData.seo ? pageContext.blogPostData.seo : null
    }

    const locale = pageContext.blogPostData.node_locale
      ? pageContext.blogPostData.node_locale
      : null

    const topicsLABEL = () => {
      let label = ''
      if (locale === LocaleCodes.ENGLISH.code) {
        label = `resource.3.TopicsLABEL.text`
      } else if (locale === LocaleCodes.JAPANESE.code) {
        label = `resource.JA.123.TopicsLABEL.text`
      } else if (locale === LocaleCodes.KOREAN.code) {
        label = `resource.KO.143.TopicsLABEL.text`
      } else if (locale === LocaleCodes.GERMAN.code) {
        label = `resource.DE.23.TopicsLABEL.text`
      } else if (locale === LocaleCodes.FRENCH.code) {
        label = `resource.FR.43.TopicsLABEL.text`
      } else if (locale === LocaleCodes.PORTUGUESE.code) {
        label = `resource.PT.63.TopicsLABEL.text`
      } else if (locale === LocaleCodes.SPANISH.code) {
        label = `resource.ES.83.TopicsLABEL.text`
      } else if (locale === LocaleCodes.CHINESE.code) {
        label = `resource.CN.103.TopicsLABEL.text`
      }

      return label
    }

    const slug = pageContext.blogPostData.slug ? pageContext.blogPostData.slug : null

    const name = pageContext.blogPostData.h1Title ? pageContext.blogPostData.h1Title : null

    const mainImageSrc =
      pageContext.blogPostData.mainImage &&
      pageContext.blogPostData.mainImage.image &&
      pageContext.blogPostData.mainImage.image.file &&
      pageContext.blogPostData.mainImage.image.file.url
        ? pageContext.blogPostData.mainImage.image.file.url
        : null

    const mainImageAlt =
      pageContext.blogPostData.mainImage && pageContext.blogPostData.mainImage.altText
        ? pageContext.blogPostData.mainImage.altText
        : null

    const body = pageContext.blogPostData.body ? pageContext.blogPostData.body : null

    const createdAt = pageContext.blogPostData.date
      ? pageContext.blogPostData.date.split('T')[0]
      : null

    let formattedDate = ''
    if (createdAt) {
      const date = new Date(createdAt)
      formattedDate = moment(date).utc().format('MMMM D, YYYY')
      formattedDate = new Date(formattedDate).toLocaleDateString(locale, OPTIONS)
    }

    const useCase =
      pageContext.blogPostData.blogCategory && pageContext.blogPostData.blogCategory.useCase
        ? pageContext.blogPostData.blogCategory.useCase
        : null

    const blogAuthor = pageContext.blogPostData.author ? pageContext.blogPostData.author : {}

    const blogTags = pageContext.blogPostData.blogTags ? pageContext.blogPostData.blogTags : []

    const formattedBlogTags = blogTags
      ? blogTags.map((tag: any) => {
          let tagName = tag.overwriteUrlText ? tag.overwriteUrlText : tag.title
          if (tagName === 'Digital Transformation') {
            tagName = 'digital-business-transformation'
          } else if (tagName === 'Automation') {
            tagName = 'enterprise-automation'
          } else if (tagName === 'Finance & Accounting (F&A)') {
            tagName = 'finance-and-accounting'
          } else if (tagName === 'Robotic Process Automation (RPA)') {
            tagName = 'robotic-process-automation'
          } else if (tagName === 'Artificial Intelligence (AI)') {
            tagName = 'artificial-intelligence'
          }
          if (isSecondaryBlog) {
            tag.url = generateSecondaryBlogSlug({
              slug: '',
              blogCategoryName: tagName,
              useCase: useCase,
              pageLocale: locale,
            })
          } else {
            tag.url = generateBlogPostSlug({
              slug: '',
              blogCategoryName: tagName,
              pageLocale: locale,
              isCollectionListing: true,
            })
          }

          return tag
        })
      : []

    const blogCategory =
      pageContext.blogPostData.blogCategory && pageContext.blogPostData.blogCategory.title
        ? pageContext.blogPostData.blogCategory.title
        : ''

    let blogCategoryFormatted = blogCategory
      ? blogCategory
          .toLowerCase()
          .replace(/ *\([^)]*\) */g, '')
          .replace(/\s/g, '-')
      : ''

    let generics: { key: string; value: any }[] = []
    generics = pageContext.blogPostData?.microcopy?.values || []

    if (blogCategoryFormatted === 'robotic-process-automation') {
      blogCategoryFormatted = 'rpa'
    } else if (blogCategoryFormatted === 'artificial-intelligence') {
      blogCategoryFormatted = 'ai'
    }

    let relatedArticles = pageContext.relatedArticles ? pageContext.relatedArticles : []
    let sameArticle = relatedArticles.findIndex(
      (post: any) => post.h1Title && name && post.h1Title.toLowerCase() === name.toLowerCase()
    )
    if (sameArticle != -1 && sameArticle !== 3) {
      relatedArticles = relatedArticles.filter(
        (post: any) => post.h1Title.toLowerCase() !== name.toLowerCase()
      )
    } else {
      relatedArticles = relatedArticles.slice(0, 3)
    }

    const blogPostPath =
      pageContext && pageContext.pageData && pageContext.pageData.path
        ? pageContext.pageData.path
        : path

    return (
      <Layout.Template
        lang={locale}
        pageType="blog"
        headerData={headerData}
        footerData={footerData}
        announcementData={announcementData}
        mainNavBannerData={mainNavBannerData}
        browserLanguageData={browserLanguageData}>
        <div data-cy="BlogPost">
          {pageContext && pageContext.blogNav && (
            <BlogNavigation
              blogNav={pageContext.blogNav}
              pagePath={blogPostPath}
              useCase={useCase}
            />
          )}
          <SEOTags seoMetadata={seoData} path={blogPostPath} slug={slug} locale={locale} />
          <BlogPostContainer isSecondaryBlogPost={isSecondaryBlog}>
            <div className="BlogPost-Bg-Container"></div>
            <Container>
              {/* Nav */}
              <div className="BlogPost__Breadcrumbs-Container">
                <Breadcrumbs
                  className="BlogPost__Breadcrumbs"
                  theme="light"
                  currentPathname={blogPostPath}
                  pageName={name}
                  isBlogBreadcrumb={true}
                  locale={locale}
                  isSecondaryBlog={isSecondaryBlog}
                />
              </div>
              <Typography type="header1">{name}</Typography>
              {/* Author Byline */}
              <div className="BlogPost__Byline">
                <Bio
                  data={blogAuthor}
                  type="bioByline"
                  blogCategoryFormatted={blogCategoryFormatted}
                  locale={pageContext.pageLocale}
                  isSecondaryBlog={isSecondaryBlog}
                  useCase={useCase}
                />
                <span className="BlogPost__Byline-Dot">•</span>
                <span className="BlogPost__Byline-Date">{formattedDate}</span>
              </div>
              {/* Featured Image */}
              <div className="BlogPost__Image-Container">
                {mainImageSrc && (
                  <WrapperImage
                    className="BlogPost__Image"
                    loading="lazy"
                    alt={mainImageAlt}
                    src={mainImageSrc && ImgUtil.getResizedImageUrl(mainImageSrc, 'width=1200')}
                    width={1200}
                    height={600}
                    threshold={650}
                  />
                )}
              </div>
              <div className="BlogPost__Post-Container">
                {/* Social Media */}
                {name && blogCategoryFormatted && slug && (
                  <div className="BlogPost__SocialMedia-Container">
                    <a
                      className="BlogPost__SocialMedia-Item"
                      target="_blank"
                      href={`https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.uipath.com%2F&ref_src=twsrc%5Etfw&text=${name
                        .split(' ')
                        .join('+')}&tw_p=tweetbutton&url=https://www.uipath.com${blogPostPath}`}>
                      <svg
                        xmlns="https://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24">
                        <path
                          d="M19.348,1.866a8.309,8.309,0,0,1-1.989,2.05q.012.172.012.516a11.265,11.265,0,0,1-.467,3.186,11.513,11.513,0,0,1-1.418,3.051,11.993,11.993,0,0,1-2.265,2.584,10.085,10.085,0,0,1-3.167,1.792,11.592,11.592,0,0,1-3.965.669A11.012,11.012,0,0,1,0,13.934a8.487,8.487,0,0,0,.958.049,7.764,7.764,0,0,0,4.923-1.694,3.974,3.974,0,0,1-3.708-2.75,5.024,5.024,0,0,0,.749.061,4.1,4.1,0,0,0,1.044-.135A3.9,3.9,0,0,1,1.688,8.1a3.831,3.831,0,0,1-.9-2.523V5.525a3.934,3.934,0,0,0,1.792.5A3.961,3.961,0,0,1,1.289,4.616,3.864,3.864,0,0,1,.81,2.725a3.885,3.885,0,0,1,.54-2A11.241,11.241,0,0,0,4.966,3.652,11.049,11.049,0,0,0,9.527,4.874a4.4,4.4,0,0,1-.1-.908,3.822,3.822,0,0,1,1.16-2.805,3.975,3.975,0,0,1,5.7.092A7.775,7.775,0,0,0,18.808.295,3.85,3.85,0,0,1,17.065,2.48,7.9,7.9,0,0,0,19.348,1.866Z"
                          transform="translate(2.326 4.286)"></path>
                      </svg>
                    </a>
                    <a
                      className="BlogPost__SocialMedia-Item"
                      target="_blank"
                      href={`https://www.linkedin.com/shareArticle?mini=true&url=https://www.uipath.com${blogPostPath}&title=text=${name
                        .split(' ')
                        .join('%20')}&summary=${name
                        .split(' ')
                        .join('%20')}&source=https%3A%2F%2Fwww.uipath.com`}>
                      <svg
                        xmlns="https://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24">
                        <path
                          d="M10.558,18.024H6.519c.017-3.356.025-5.954.025-7.943s0-3.234-.013-3.634l-.013-.589h4.039V7.585a5.3,5.3,0,0,1,.479-.649,5.226,5.226,0,0,1,.694-.638A3.2,3.2,0,0,1,12.8,5.764a4.883,4.883,0,0,1,1.4-.19,4.381,4.381,0,0,1,3.377,1.393,5.871,5.871,0,0,1,1.276,4.082v6.972H14.818V11.516a3.569,3.569,0,0,0-.5-2.02,1.752,1.752,0,0,0-1.552-.73,2,2,0,0,0-1.3.423,2.631,2.631,0,0,0-.779,1.049,2.985,2.985,0,0,0-.135.995v6.79Zm-6.273,0H.233V5.856H4.285V18.022ZM2.259,4.2H2.235A2.228,2.228,0,0,1,.614,3.6,2.021,2.021,0,0,1,0,2.1,1.984,1.984,0,0,1,.633.6,2.319,2.319,0,0,1,2.283,0,2.253,2.253,0,0,1,3.916.6a2.055,2.055,0,0,1,.626,1.5,1.951,1.951,0,0,1-.62,1.5A2.324,2.324,0,0,1,2.259,4.2Z"
                          transform="translate(2.571 2.96)"></path>
                      </svg>
                    </a>
                    <a
                      className="BlogPost__SocialMedia-Item"
                      target="_blank"
                      href={`https://www.facebook.com/sharer/sharer.php?u=https://www.uipath.com${blogPostPath}&display=popup&ref=plugin&src=like&kid_directed_site=0`}>
                      <svg
                        xmlns="https://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24">
                        <path
                          d="M10.607.147V3.388H8.68a1.8,1.8,0,0,0-1.424.442,2.034,2.034,0,0,0-.368,1.326v2.32h3.6l-.479,3.634H6.887v9.318H3.131V11.11H0V7.477H3.131V4.8A4.749,4.749,0,0,1,4.407,1.258,4.634,4.634,0,0,1,7.808,0,20.309,20.309,0,0,1,10.607.147Z"
                          transform="translate(6.881 1.143)"></path>
                      </svg>
                    </a>
                  </div>
                )}
                {/* Post Body */}
                <div className="BlogPost__Body-Container">
                  <div className="BlogPost__Body">{body && renderRichText(body)}</div>
                  {/* BlogFeatured Resource */}
                  <BlogFeaturedResource
                    slug={slug}
                    data={pageContext.blogPostData?.blogFeaturedResources?.[0]}
                  />
                  {/* Topics */}
                  {formattedBlogTags?.length > 0 ? (
                    <TagsContainer>
                      <div className="Tags__Group">
                        <Typography type="label" className="Tags__Heading">
                          {findTarget(topicsLABEL(), generics) || 'Topics:'}
                        </Typography>
                        {formattedBlogTags &&
                          formattedBlogTags.map((tag: any) => {
                            let url = tag.url
                            return (
                              <a key={tag.title} className="Tag" href={url}>
                                {tag.title}
                              </a>
                            )
                          })}
                      </div>
                    </TagsContainer>
                  ) : null}

                  {/* Author miniBio */}
                  <div className="BlogPost__Author">
                    {/* <Bio data={blogAuthor} type="bioShortDescription" /> */}
                    <Bio
                      data={blogAuthor}
                      type="bioShortDescription"
                      blogCategoryFormatted={blogCategoryFormatted}
                      locale={pageContext.pageLocale}
                      isSecondaryBlog={isSecondaryBlog}
                      useCase={useCase}
                    />
                  </div>
                </div>
              </div>
            </Container>
            {/* Related Articles */}
            <div className="BlogPost__Related-Articles">
              <RelatedArticles data={relatedArticles} locale={locale} />
            </div>
            {/* Subscribe */}

            <Subscribe data={pageContext.subscribe} />
            <SubscribeModal data={pageContext.subscribe} lastForm={true} />
          </BlogPostContainer>
        </div>
      </Layout.Template>
    )
  }
  return null
}

export default BlogPost
